import React from "react";

/**
 * NexsoLogo — the Nexso brand mark.
 *
 * A rounded blue square with a white "N" letter inside. Used across the app
 * (login, register, dashboard sidebar, landing nav, download page, etc.) as
 * the app's identity mark. Sizes match the previous TV-icon-in-blue-square
 * containers so drop-in swaps look identical apart from the glyph.
 *
 * Sizes:
 *   xs → 24px (h-6 w-6)   · sidebar-collapsed
 *   sm → 28px (h-7 w-7)   · mobile dashboard header
 *   md → 36px (h-9 w-9)   · default (landing nav, login/register, download)
 *   lg → 40px (h-10 w-10) · dashboard hero, footer of setup page
 *   xl → 48px (h-12 w-12) · billing card icon, dashboard tiles
 *   2xl→ 64px (h-16 w-16) · marketing hero blocks
 *
 * Optional props:
 *   shape="rounded" (default rounded-xl) | "square" (rounded-lg) | "pill" (rounded-2xl)
 *   className — extra classes for the outer square
 */
const SIZE_MAP = {
  xs:  { box: "h-6 w-6",   text: "text-xs",  radius: "rounded-md",  shadow: "" },
  sm:  { box: "h-7 w-7",   text: "text-sm",  radius: "rounded-lg",  shadow: "" },
  md:  { box: "h-9 w-9",   text: "text-lg",  radius: "rounded-xl",  shadow: "shadow-md" },
  lg:  { box: "h-10 w-10", text: "text-xl",  radius: "rounded-xl",  shadow: "shadow-sm" },
  xl:  { box: "h-12 w-12", text: "text-2xl", radius: "rounded-2xl", shadow: "shadow-sm" },
  "2xl": { box: "h-16 w-16", text: "text-3xl", radius: "rounded-2xl", shadow: "shadow-lg" },
};

export function NexsoLogo({ size = "md", shape, className = "", textColor = "text-white" }) {
  const s = SIZE_MAP[size] || SIZE_MAP.md;
  const radius = shape === "square" ? "rounded-lg" : shape === "pill" ? "rounded-2xl" : s.radius;
  return (
    <div
      className={`${s.box} ${radius} ${s.shadow} bg-gradient-to-br from-sky-400 to-sky-600 flex items-center justify-center ${className}`}
      aria-label="Nexso"
    >
      <span
        className={`${textColor} ${s.text} font-bold leading-none tracking-tight`}
        style={{ fontFamily: "Outfit, sans-serif" }}
      >
        N
      </span>
    </div>
  );
}

export default NexsoLogo;
